// extracted by mini-css-extract-plugin
export default {"topRow":"Eob5GF3wzMwLxwyhVyQu","titleBox":"qZUS94xYuhZUOxOlSWyU","btnBox":"BLXQEE0BEmtc3INOtwH0"};